var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 0C4.19167 0 0 1.29167 0 3.75V7.91667C0 10.375 4.19167 11.6667 8.33333 11.6667C12.475 11.6667 16.6667 10.375 16.6667 7.91667V3.75C16.6667 1.29167 12.475 0 8.33333 0ZM1.66667 7.91667V6.08333C2.15 6.36667 2.70833 6.6 3.33333 6.8V9.2C2.24167 8.775 1.66667 8.25833 1.66667 7.91667ZM11.6667 7.20833V9.68333C10.9417 9.83333 10.1083 9.94167 9.16667 9.98333V7.48333C10.025 7.45 10.8667 7.35 11.6667 7.20833ZM7.5 7.48333V9.98333C6.55833 9.94167 5.725 9.83333 5 9.68333V7.20833C5.8 7.35 6.64167 7.45 7.5 7.48333ZM13.3333 9.20833V6.80833C13.9583 6.60833 14.5167 6.375 15 6.09167V7.925C15 8.275 14.425 8.78333 13.3333 9.20833ZM8.33333 5.84167C4.01667 5.84167 1.66667 4.46667 1.66667 3.75833C1.66667 3.05 4.01667 1.675 8.33333 1.675C12.65 1.675 15 3.05 15 3.75833C15 4.46667 12.65 5.84167 8.33333 5.84167Z",
    fill: "#4C6484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditsIcon);
export default __webpack_public_path__ + "static/media/credits-icon.1c143663193bf9819e6329bf55b39c9e.svg";
export { ForwardRef as ReactComponent };